angular.module('impactx.login').controller('LoginSamlCtrl', LoginSamlCtrl);

LoginSamlCtrl.$inject = ['LoginService', '$securityManager', '$routeParams', 'dataGen'];

function LoginSamlCtrl(LoginService, $securityManager, $routeParams, dataGen) {
   var token = $routeParams.token;
    $securityManager.setToken(token);
    dataGen.getData({}, {}, "/prepareexternallogin").then(function() {
        LoginService.refreshUI(true);
    });
}